// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Xi6_3","tabContainer":"style_tabContainer__Zh2CG","bpMediumUp":"style_bpMediumUp__UC9uS","tabPanel":"style_tabPanel__T0TgL"};